import { Injectable } from '@angular/core';

import moment from 'moment-timezone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Helpers } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';

import { SchedulerAvailability } from './types';

@Injectable({ providedIn: 'root' })
export class ViewboxInterviewScheduleHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadItem(
    scheduleToken: string,
    requestLinkToken: string,
    candidateTimezone: string,
  ): Observable<SchedulerAvailability> {
    return this.httpApi
      .get(
        `/share/interview/availability/${scheduleToken}/${requestLinkToken}`,
        { candidate_timezone: candidateTimezone },
        { addToken: false },
      )
      .pipe(
        map(data => Helpers.fillInReferences(this.sortDates(data.availability), data.references)),
      );
  }

  public confirmSchedule(
    scheduleToken: string,
    requestLinkToken: string,
    startsAt: string,
    candidateTimezone: string,
  ): Observable<SchedulerAvailability> {
    const body = {
      interviewEvent: { startsAt, candidateTimezone },
    };

    return this.httpApi
      .post(`/share/interview/availability/${scheduleToken}/${requestLinkToken}`, {}, body, {
        addToken: false,
      })
      .pipe(map(data => Helpers.fillInReferences(data.availability, data.references)));
  }

  private sortDates(data: SchedulerAvailability): SchedulerAvailability {
    data.days = [...data.days].sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf());

    return data;
  }
}
